import React from 'react';
import { debounce } from 'shared/utils';

class QuantityPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value };
    this.updateInternalValue = this.updateInternalValue.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.debouncedBlur = debounce(this.blur.bind(this), 1000);
  }

  isValid(n) {
    return Number(n) >= Number(this.props.min) && Number(n) <= Number(this.props.max);
  }

  updateInternalValue(e) {
    const value = Number(e.target.value);
    if (String(value).length <= this.props.maxLength) this.setState({ value });
    this.debouncedBlur();
  }

  blur() {
    if (this.input === document.activeElement) this.input.blur();
  }

  updateValue() {
    if (Number(this.state.value) !== this.props.value) {
      if (this.isValid(this.state.value)) {
        return this.props.onChange(Number(this.state.value))
      } else {
        this.setState({ value: this.props.value });
      }
    }
  }

  render() {
    return (
      <input
        className={this.props.className}
        min={this.props.min}
        max={this.props.max}
        maxLength={this.props.maxLength}
        type="number"
        value={this.state.value}
        onChange={this.updateInternalValue}
        onBlur={this.updateValue}
        disabled={this.props.disabled}
        ref={(input) => this.input = input}
      />
    )
  }
}

QuantityPicker.defaultProps = {
  min: 0,
  max: 999,
  maxLength: 3
}

export default QuantityPicker;



// WEBPACK FOOTER //
// ./shared/components/ui/quantityPicker/index.js